import { Box, Typography } from "@mui/material";
import { useBRLmoney } from "../../../../hooks/useBRLmoney";
import { colors } from "../../../../theme/colors";
import { useBreakpoints } from "../../../../hooks/useBreakpoins";

export function ProductComponent({
  selectedOrdersXproducts,
  changeQuantityToCancel,
}: {
  selectedOrdersXproducts: ItensToCancel[];
  changeQuantityToCancel?: (val: ItensToCancel[]) => void;
}) {
  const { BRLmoney } = useBRLmoney();
  const { isMobile } = useBreakpoints();

  // const changeQTDCancel = (quandity: number, productID: number) => {
  //   const find = selectedOrdersXproducts.find(
  //     (item) => item.productsId === productID
  //   );
  //   find.quantityToCancel = quandity;

  //   const filter = selectedOrdersXproducts.filter(
  //     (prd) => prd.productsId !== productID
  //   );

  //   changeQuantityToCancel([...filter, find]);
  // };
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        width: "100%",
        maxWidth: 1500,
        justifyContent: isMobile ? "center" : "flex-start",
        overflowX: "auto",
        gap: 1,
        pt: 3,
        pb: 3,
      }}
    >
      {selectedOrdersXproducts?.map((item, index) => (
        <Box
          key={index}
          display={"flex"}
          alignItems={"center"}
          flexDirection={"column"}
          width={230}
          sx={{ background: "#FFFFFF", borderRadius: 3 }}
        >
          <Box
            display={"flex"}
            alignItems={"center"}
            flexDirection={"column"}
            justifyContent={"center"}
          >
            {item?.isCanceled && (
              <Box
                sx={{
                  background: "red",
                  position: "absolute",
                  transform: "rotate(45deg)",
                  width: 250,
                  borderRadius: 2,
                }}
              >
                <Typography textAlign={"center"} color="#FFFFFF">
                  CANCELADO
                </Typography>
              </Box>
            )}
            {item?.isCanceled && item?.canceledWithRefund && (
              <Box
                sx={{
                  background: "red",
                  position: "absolute",
                  transform: "rotate(45deg)",
                  width: 230,
                  mt: 5,
                  ml: -4,
                  borderRadius: 2,
                }}
              >
                <Typography textAlign={"center"} color="#FFFFFF">
                  VALOR DEVOLVIDO
                </Typography>
              </Box>
            )}
            <Box width={150} height={150} pl={1}>
              <img
                src={item?.Products?.productsImages[0]?.code}
                style={{
                  objectFit: "contain",
                  width: 150,
                  height: 150,
                  borderRadius: 5,
                }}
                alt={item?.Products?.name}
              />
            </Box>

            <Typography
              overflow={"hidden"}
              ml={1}
              textOverflow={"ellipsis"}
              textAlign={"center"}
              height={48}
            >
              {item?.Products?.name}
            </Typography>

            <Box
              width={200}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Typography
                minWidth={100}
                textAlign={"center"}
                width={"100%"}
                fontSize={14}
                color={colors.purple[500]}
              >
                Quantidade
              </Typography>
              <Typography
                textAlign={"center"}
                width={"100%"}
                fontSize={16}
                fontWeight={600}
                color={colors.purple[500]}
              >
                {item?.quantity}
              </Typography>
            </Box>

            <Box
              width={200}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Typography
                minWidth={100}
                textAlign={"center"}
                width={"100%"}
                fontSize={14}
                color={colors.purple[500]}
              >
                Valor total
              </Typography>

              <Typography
                sx={{
                  fontSize: "18px",
                  fontWeight: 500,
                  textAlign: "left",
                  color: colors.textGrey[500],
                }}
              >
                {BRLmoney(item?.boughtPrice * item?.quantity)}
              </Typography>
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
}
